import { ReloadOutlined } from "@ant-design/icons";
import { Button, Modal, Table } from "antd";
import { useEffect, useState } from "react";
import { IoIosCopy } from "react-icons/io";
import apiFactory from "../../../api";
import { StoreVersionModal } from "../../../components/modal/adminSetting/StoreVersionModal";
import { VersionPreviewFile } from "../../../components/setting/VersionPreviewFile";
import { useAdminSettingContext } from "../../../context/AdminSettingContext";
import { useInfoUser } from "../../../store/UserStore";
import { handleCopy } from "../../../utils/Utils";
import { RenderMobileList } from "./RenderMobileList";

const VersionList = ({ isMobile }) => {
  const { user, languageMap } = useInfoUser();
  const [isLoading, setIsLoading] = useState(false);
  const { selectedApp, versionList, setVersionList } = useAdminSettingContext();
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [isOpenVersionModal, setIsOpenVersionModal] = useState(false);

  const columns = [
    {
      title: `${languageMap?.["as.menu.version.table.type"] ?? "App name"}`,
      dataIndex: "appName",
      key: "appName",
    },
    {
      title: `${languageMap?.["as.menu.version.table.type"] ?? "Type"}`,
      dataIndex: "type",
      key: "type",
    },
    {
      title: `${languageMap?.["as.menu.version.table.name"] ?? "Name"}`,
      dataIndex: "name",
      key: "name",
    },
    {
      title: `${languageMap?.["as.menu.version.table.order"] ?? "Order"}`,
      dataIndex: "order",
      key: "order",
    },
    {
      title: `${languageMap?.["as.menu.version.table.file"] ?? "File"}`,
      dataIndex: "file",
      key: "file",
      width: "300px",
      render: (file, record) =>
        file?.originalName && (
          <VersionPreviewFile
            file={file}
            percentProgress={0}
            totalVolume={100}
            path="public"
          />
        ),
    },
    {
      title: `${languageMap?.["as.menu.version.table.name"] ?? "Other link"}`,
      dataIndex: "otherLink",
      key: "otherLink",

      render: (link, record) =>
        link && (
          <button onClick={() => handleCopy(link)}>
            <IoIosCopy size={17} color={"#2fa724ff"} />
          </button>
        ),
    },
  ];

  const fetchVersionList = async () => {
    setIsLoading(true);
    try {
      const result = await apiFactory.versionApi.getList({
        appId: selectedApp?.appId,
      });

      if (result?.status === 200) {
        setVersionList(
          result?.data?.map((version) => ({
            ...version,
            appName: selectedApp?.name,
            type: selectedApp?.type,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching file list data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const onRemove = (record) => {
    setSelectedVersion(record);
  };

  const onDoubleClick = (record) => {
    setSelectedVersion(record);
    setIsOpenVersionModal(true);
  };

  const onClick = (record) => {
    // setSelectedApp(record);
  };

  const cancelModal = () => {
    setIsOpenVersionModal(false);
    setSelectedVersion(null);
  };

  useEffect(() => {
    fetchVersionList();
  }, [selectedApp]);

  return (
    <>
      {isMobile ? (
        <Modal
          title={
            languageMap?.["as.menu.document.table.mobileTitle"] ?? "File list"
          }
          // open={selectedProgram}
          // onCancel={() => {
          //   setSelectedProgram(null);
          // }}
          footer={null}
          centered
          width={"100%"}
        >
          <RenderMobileList
            data={versionList}
            onRemove={onRemove}
            loading={isLoading}
            // selectedProgram={selectedProgram}
            languageMap={languageMap}
            isProgramList={false}
          />
        </Modal>
      ) : (
        <>
          <div className="file-list">
            <div
              className="my-alarm"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <div className="flex justify-between gap-[10px]">
                <div className="font-semisolid">Version list</div>
                <ReloadOutlined
                  className="text-[20px]"
                  onClick={fetchVersionList}
                />
              </div>
              <div>
                <Button
                  type="primary"
                  onClick={() => setIsOpenVersionModal(true)}
                >
                  Create version
                </Button>
              </div>
            </div>
            <div>
              <Table
                columns={columns}
                dataSource={versionList}
                pagination={false}
                onRow={(record, index) => ({
                  onDoubleClick: (e) => onDoubleClick(record),
                  onClick: (e) => onClick(record),
                  // className: getSelectedColor(record),
                  // ref:
                  //   isLoadMoreData && index === userList?.length - 1
                  //     ? lastRecordRef
                  //     : null,
                })}
                size={"middle"}
                loading={isLoading}
                rowKey={(record) => record.key}
                rowClassName="admin-setting-table-row"
                scroll={{
                  x: 700,
                  y: 300,
                }}
              />
            </div>
          </div>
        </>
      )}

      {isOpenVersionModal && (
        <StoreVersionModal
          isModalOpen={isOpenVersionModal}
          title={selectedVersion ? "Update version" : "Create version"}
          selectedVersion={selectedVersion}
          cancelModal={cancelModal}
          setVersionList={setVersionList}
          versionList={versionList}
        />
      )}
    </>
  );
};
export { VersionList };
